import { all } from 'redux-saga/effects';
import { watchEvents } from '../modules/Events/sagas';
import { watchNotifications } from '../modules/Notifications/sagas';
import { watchWishlists } from '../modules/WishLists/sagas';

export default function* rootSaga() {
  yield all([watchNotifications(), watchEvents(), watchWishlists()]);
}
